import { render, staticRenderFns } from "./PriceListsForm.vue?vue&type=template&id=0c951849&"
import script from "./PriceListsForm.vue?vue&type=script&lang=js&"
export * from "./PriceListsForm.vue?vue&type=script&lang=js&"
import style0 from "./PriceListsForm.vue?vue&type=style&index=0&id=0c951849&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports